<script>
export default {
  data() {
    return {
      attrs: []
    }
  },
  methods: {
    fetchCalendarTasks(data) {
      let {month, year} = 0;

      if (data === undefined) {
        month = parseInt(this.$moment().format("M"));
        year = parseInt(this.$moment().format("YYYY"));
      } else {
        month = data.month;
        year = data.year;
      }

      this.$axios
        .post(`api/GeneralTasks/GetCalendar`, {
          idUser: this.user.id,
          mes: month,
          año: year
        })
        .then((response) => {
          this.attrs = [
            ...response.data.map((element) => ({
              dates: this.$moment(element.start).toDate(),
              bar: element.class,
              popover: {
                label: element.title
              }
            }))
          ];

          this.attrs.push({
            key: "today",
            highlight: "blue",
            dates: new Date()
          });
        });
    },
    goToCalendar(event) {
      // console.log("event :>> ", event);
      this.$router.push({ name: "calendar", params: { today: event.id }  });
    }
  }
}
</script>
